export const SET_PRODUCTS = "SET_PRODUCTS";
export const setProducts = products => ({
  type: SET_PRODUCTS,
  products
});

export const SORT_PRODUCTS = "SORT_PRODUCTS";
export const sortProducts = sortBy => ({
  type: SORT_PRODUCTS,
  sortBy
});

export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";
export const clearProducts = () => ({ type: CLEAR_PRODUCTS });
